<template>
  <div>
    <div class="navigation">
      <div class="container-1170">
        <a class="navigation-logo" href="/"><i class="">魔期AI平台 充值续费</i></a>
        <ul class="navigation-left">
          <!-- <li><a href="#intro">主页</a></li>
          <li><a href="#services">产品介绍</a></li>
          <li><a href="#cost">订阅价格</a></li>
          <li><a href="#about">关于我们</a></li>
          <li><a href="#contact">联系我们</a></li> -->
        </ul>
      </div>
	  </div>
  </div>
</template>
<script>
import { onMounted, onUnmounted, reactive } from 'vue'

export default {
  setup (props, { emit }) {
    const obj =  reactive({

    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
    })

    // 菜单点击事件
    const handleSelect = (key) => {
      emit('topbarEvent', key) // 抛出事件到父组件
    }

    return {
      obj,
      handleSelect
    }
  }
}
</script>
<style lang="scss" scoped>
.navigation {
  width: 100%;
  min-height: 64px;
  position: fixed;
  top: 0;
  background-color: white;
  color: #303133;
  border-bottom: solid 1px #E4E7ED;
}

.navigation-logo {
  float: left;
  margin-top: 20px;
  color: #66b1ff;
  text-decoration: none;
  font-size: 26px;
  line-height: 26px;
}

.logo-icon {
  display: inline-block;
  background-image: url(https://~.png);
  background-repeat: no-repeat;
  background-position: -120px 0px;
  width: 90px;
  height: 23px;
}

.navigation-left {
  float: left;
  margin: 0px 100px;
}

.navigation-left > li {
  display: inline-block;
  margin: 22px 10px;
  vertical-align: middle;
}

.navigation-left > li > a {
  font-size: 16px;
  text-decoration: none;
  color: #303133;
}

.navigation-left > li > a:hover {
  font-size: 16px;
  text-decoration: none;
  color: #66b1ff;
}

.navigation-left .active {
  color: #66b1ff;
}

.navigation-left .active a {
  color: #66b1ff;
}

.navigation-left .active a:hover {
  color: #66b1ff;
}

.navigation-right {
  float: right;
  margin: 0;
}

.navigation-right > li {
  display: inline-block;
  margin: 16px 10px;
  vertical-align: middle;
}

.navigation-right > li > a {
  font-size: 14px;
  text-decoration: none;
  color: #c0c0c0;
  opacity: 0.6;
}

.navigation-right > li > a:hover {
  font-size: 14px;
  text-decoration: none;
  color: #dedede;
  opacity: 0.9;
}

.nav-right-icon-1 {
  display: inline-block;
  background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
  background-position: -260px 0px;
  width: 22px;
  height: 23px;
}

.nav-right-icon-2 {
  display: inline-block;
  background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
  background-position: -300px 0px;
  width: 30px;
  height: 23px;
}

.nav-right-icon-3 {
  display: inline-block;
  z-index: -2;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  opacity: 1;
  vertical-align: middle;
  margin-right: 5px;
}

.nav-right-icon-4 {
  display: inline-block;
  background-image: url(https://d3e54v103j8qbb.cloudfront.net/gen/img/sprites/dashboard.1ebba33808.png);
  background-repeat: no-repeat;
  background-position: -20px -40px;
  width: 9px;
  height: 6px;
}
</style>
